import { Card, Checkbox, Form, Button, Divider } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "antd/es/form/Form";
 const careAdminOption = [
  "all_tickets",
  "my_tickets",
  "clinicians",
  "offline_registration",
  "coupons",
  "patients",
  "medicines",
  "consultations",
  "billing",
  "vendor",
];
 const superAdminOptions = ["ticket_management", "user_management"];

const clinicianOptions = ["my_appointments", "my_patients"];
export const getOptionsForRole = (role) => {
  switch (role) {
    case "care_admin":
      return careAdminOption;
    case "super_admin":
      return superAdminOptions;
    case "doctor":
      return clinicianOptions;
    default:
      return [];
  }
};

function SuperAdminModulesNew({ selectedRole, form, editData,handleFieldChange }) {  

  const [checkAllState, setCheckAllState] = useState({});

  const getOptionsForRole = (role) => {
    switch (role) {
      case "care_admin":
        return careAdminOption;
      case "super_admin":
        return superAdminOptions;
      case "doctor":
        return clinicianOptions;
      default:
        return [];
    }
  };

  useEffect(() => {
    if (editData && editData.page_access) {
      const initialModules = {};
      const initialCheckAllState = {};

      selectedRole.forEach((role) => {
        const options = getOptionsForRole(role);
        const roleAccess = editData.page_access[role] || {};

        // Convert the true values to an array of selected modules
        initialModules[role] = Object.keys(roleAccess).filter(
          (module) => roleAccess[module]
        );

        // Set check all state if all options for the role are selected
        initialCheckAllState[role] =
          initialModules[role].length === options.length;
      });

      form.setFieldsValue({ modules: initialModules });
      setCheckAllState(initialCheckAllState);
    }
  }, [editData]);

  const handleSelectAll = (role, options, isChecked) => {
    handleFieldChange();
    const currentModules = form.getFieldValue("modules") || {};
    currentModules[role] = isChecked ? options : [];
    form.setFieldsValue({ modules: currentModules });

    setCheckAllState((prevState) => ({
      ...prevState,
      [role]: isChecked,
    }));
  };

  const handleCheckboxChange = (role, option) => {
    handleFieldChange();
    const currentModules = form.getFieldValue("modules") || {};
    const roleModules = currentModules[role] || [];
    const newCheckedList = roleModules.includes(option)
      ? roleModules.filter((item) => item !== option)
      : [...roleModules, option];

    currentModules[role] = newCheckedList;
    form.setFieldsValue({ modules: currentModules });

    setCheckAllState((prevState) => ({
      ...prevState,
      [role]: newCheckedList.length === getOptionsForRole(role).length,
    }));
  };
  return (
    <>
      {selectedRole.map((role) => {
        const optionsToRender = getOptionsForRole(role);
        const checkedList = form.getFieldValue(["modules", role]) || [];
        const checkAll = checkAllState[role] || false;

        return (
          <Card key={role} style={{ marginBottom: "20px" }}>
            <div style={{ marginBottom: "15px" }}>
              Modules to be shown for {role.replace("_", " ")}
            </div>
            <div style={{ margin: "10px 0px" }}>
              <Checkbox
                onChange={(e) =>
                  handleSelectAll(role, optionsToRender, e.target.checked)
                }
                checked={checkAll}
              >
                Select all
              </Checkbox>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "8px",
              }}
            >
              {optionsToRender.map((option) => (
                <Checkbox
                  key={option}
                  value={option}
                  checked={checkedList.includes(option)}
                  onChange={() => handleCheckboxChange(role, option)}
                  style={{ marginBottom: "8px" }}
                >
                  {option
                    .split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </Checkbox>
              ))}
            </div>
          </Card>
        );
      })}
    </>
  );
}

export default SuperAdminModulesNew;
